
import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      question: 'How long does it take to build my funnel?',
      answer: 'Most funnels are completed within 3-7 days depending on complexity. Simple funnels can be done in 3 days, while more complex enterprise funnels may take up to 7 days. We always deliver on time or earlier.'
    },
    {
      question: 'Do you work with ClickFunnels and GoHighLevel?',
      answer: 'Yes! We specialize in both ClickFunnels and GoHighLevel. We can build your funnel in either platform based on your preference and business needs. Both platforms have their unique advantages.'
    },
    {
      question: 'What if I\'m not satisfied with my funnel?',
      answer: 'We offer a 100% money-back guarantee within 30 days. If you\'re not completely satisfied with your funnel, we\'ll refund your entire payment, no questions asked. Your success is our priority.'
    },
    {
      question: 'Do you provide ongoing support after delivery?',
      answer: 'Yes! All our packages include post-delivery support ranging from 30-90 days depending on your plan. We also offer 24/7 support for any technical issues or questions you may have.'
    },
    {
      question: 'Can you integrate my funnel with email marketing platforms?',
      answer: 'Absolutely! We integrate with all major email platforms including Mailchimp, ActiveCampaign, ConvertKit, GetResponse, and many others. We also set up automated email sequences to maximize conversions.'
    },
    {
      question: 'Do you optimize funnels for mobile devices?',
      answer: 'Yes, all our funnels are fully responsive and optimized for mobile devices. With over 60% of traffic coming from mobile, we ensure your funnel looks perfect and converts well on all devices.'
    },
    {
      question: 'What makes your funnels convert better than others?',
      answer: 'Our funnels are built using proven conversion principles, A/B tested elements, and psychological triggers. We analyze successful funnels in your industry and implement best practices that have generated millions in revenue.'
    },
    {
      question: 'Do you provide training on how to use my funnel?',
      answer: 'Yes! We provide complete training documentation and video tutorials showing you how to manage, update, and optimize your funnel. We want you to be completely comfortable using your new sales system.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Got questions? We have answers. If you don't see your question here, feel free to contact us.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenFAQ(openFAQ === index ? -1 : index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200 cursor-pointer"
              >
                <span className="font-medium text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-${openFAQ === index ? 'subtract' : 'add'}-line text-xl text-blue-600 flex-shrink-0`}></i>
              </button>
              
              {openFAQ === index && (
                <div className="px-6 pb-4">
                  <div className="text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Still have questions?</p>
          <a
            href="#contact"
            className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 font-medium whitespace-nowrap"
          >
            <i className="ri-message-3-line mr-2"></i>
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}
